import { createTheme } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export function getMuiPopupContainer() {
  // Use the fullscreen element if in fullscreen mode, otherwise just the document's body
  return document.fullscreenElement ?? document.body;
}

export const dispatchTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      xxl: 1920,
      quad: 2560,
      ultra: 3840,
      wideUltra: 5760,
    },
  },
  typography: {
    fontFamily: "Manrope",
  },
  shape: {
    borderRadius: 12,
  },
  palette: {
    primary: {
      main: colors.brandBlue500,
    },
  },
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px !important",
        },
      },
    },
    MuiMenu: {
      defaultProps: {
        container: getMuiPopupContainer,
      },
    },
    MuiTooltip: {
      defaultProps: {
        PopperProps: {
          container: getMuiPopupContainer,
        },
      },
    },
    MuiDrawer: {
      defaultProps: {
        container: getMuiPopupContainer,
      },
    },
    MuiModal: {
      defaultProps: {
        container: getMuiPopupContainer,
      },
    },
  },
});
